export const LEAD_FORM_STATES = {
  LOADING: 'loading',
  HIDDEN: 'hidden',
  LEAD_FORM: 'leadForm',
  THANK_YOU: 'thankYou',
  LOAD_DATA_ERROR: 'loadDataError',
  SUBMIT_LEAD_ERROR: 'submitLeadError',
  LOAD_THANK_YOU_ERROR: 'loadThankYouError',
};
